import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import DateField from './form/DateField';

const SchedulerModal = (props) => {
  const { t, isOpen, toggleFunction, onScheduleFinish, initialDate } = props;

  const [selectedDate, setSelectedDate] = useState(initialDate);

  const onDateChange = (value) => {
    setSelectedDate(value);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleFunction} className="modal-scheduler">
      <ModalHeader toggle={toggleFunction}>
        {t('communication.select-date-to-send')}
      </ModalHeader>
      <ModalBody>
        <div className="form__form-group">
          <div className="form_form-group-field">
            <Field
              name="scheduledTo"
              component={DateField}
              placeholder={t('school-term.placeholders.initial-date')}
              onChange={onDateChange}
              showInline
              showTimeSelect
              minDate={new Date()}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleFunction}>
          {t('general.cancel')}
        </Button>
        <Button
          color="success"
          onClick={() => {
            onScheduleFinish(selectedDate);
            toggleFunction();
          }}
        >
          {t('general.confirm')}
        </Button>{' '}
      </ModalFooter>
    </Modal>
  );
};

SchedulerModal.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleFunction: PropTypes.func.isRequired,
  onScheduleFinish: PropTypes.func.isRequired,
  initialDate: PropTypes.shape(PropTypes.shape).isRequired,
};

export default withTranslation('common')(SchedulerModal);
